import { apiFetch } from '../client';
import type { PasswordPolicy } from '../../lib/passwordRules';

/**
 * Endpoints PÚBLICOS del rbac — Public API, SIN auth (authType NONE, igual que /auth/* y
 * /healthcheck). No exponen PII ni secretos.
 *
 * NOTA DE CONTRATO (deuda): el OpenAPI todavía no expone el schema de `GET /public/password-policy`
 * (Ola 1: el backend lo agrega en T-openapi). Hasta el regen (`npm run sync-api-types`) tipamos la
 * respuesta con `PasswordPolicy` (tipo LOCAL temporal en lib/passwordRules). Cuando el OpenAPI
 * exponga el schema, reemplazar por el tipo generado de `public.gen.ts` y borrar el local.
 */
export const publicApi = {
    /** Reglas de complejidad de contraseña efectivas del lambda desplegado (DEC-RBAC-052). */
    getPasswordPolicy: () =>
        apiFetch<PasswordPolicy>('/public/password-policy', {
            method: 'GET',
            skipRefresh: true,
        }),
};
